import { all, call, put, fork, takeEvery, select } from 'redux-saga/effects';
import { showSurveyGroupQuestionMessage } from 'actions/SurveyGroupQuestion';
import { onSaveSurveyGroup } from 'actions/SurveyGroup';
import { ON_SAVE_SURVEY_GROUP_QUESTION } from 'constants/ActionTypes';

const getSelectedSurveyGroup = (state) => state.surveyGroups.selectedSurveyGroup;

function* saveSurveyGroupQuestion({ payload }) {
    try {
        const selectedSurveyGroup = yield select(getSelectedSurveyGroup);
        const savedSurveyGroupQuestions = yield call(saveSurveyGroupQuestionRequest, selectedSurveyGroup, payload);
        yield put(onSaveSurveyGroup(savedSurveyGroupQuestions));
    } catch (error) {
        yield put(showSurveyGroupQuestionMessage(error.messages));
    }
}

const saveSurveyGroupQuestionRequest = async (selectedSurveyGroup, payload) => {
    // simply add to the selected survey group question list and then call save the survey group.
    try {
        if (selectedSurveyGroup && selectedSurveyGroup.questions) {
            selectedSurveyGroup.questions.push(payload.id);
        } else {
            const questions = [];
            questions.push(payload.id);
            selectedSurveyGroup.questions = questions;
        }
        return selectedSurveyGroup;
    } catch (error) {
        throw error;
    }
};

export function* saveSurveyGroupQuestionSaga() {
    yield takeEvery(ON_SAVE_SURVEY_GROUP_QUESTION, saveSurveyGroupQuestion);
}

export default function* rootSaga() {
    yield all([fork(saveSurveyGroupQuestionSaga)]);
}


// WEBPACK FOOTER //
// ./sagas/SurveyGroupQuestion.js